import classNames from "classnames";
import React from "react";
import { IoMdInformationCircle } from "react-icons/io";
import { Tooltip as ReactTooltip } from "react-tooltip";

import { InfoTooltipProps } from "./InfoTooltip.types";

export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  id,
  content,
  place = "top",
  ariaLabel = "More information",
  size = 18,
  className,
  iconClassName,
  tooltipClassName,
}) => {
  return (
    <>
      <span
        tabIndex={0}
        role={"img"}
        aria-label={ariaLabel}
        className={classNames(
          "inline-flex shrink-0 cursor-help items-center justify-center rounded-full text-[#A1AFC0] transition hover:text-[#7C8B9A] focus:outline-none focus:ring-2 focus:ring-[#A1AFC0]/40",
          className,
        )}
        data-tooltip-id={id}>
        <IoMdInformationCircle
          size={size}
          className={classNames("text-current", iconClassName)}
        />
      </span>
      <ReactTooltip
        id={id}
        place={place}
        positionStrategy={"fixed"}
        className={classNames(
          "z-[10000] !max-w-[240px] !rounded !bg-[#333333] !px-3 !py-2 !text-left !text-xs !font-semibold !leading-4 !text-white",
          tooltipClassName,
        )}>
        {content}
      </ReactTooltip>
    </>
  );
};
